import axios from 'axios'

export function setUserCurrentLocation ({Vue, commit}) {
    navigator.geolocation.getCurrentPosition(function(position) {
        commit('setUserCurrentLocation', position.coords.latitude + ','+ position.coords.longitude);
    }, function() {
        commit('setUserCurrentLocation', 'My+Location');
    });
}


/* Payload é um Json object que tem de fazer match com SearchRequest*/
export function performSearch ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/search',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}
export function performSearchProtocolos ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/searchprotocolos',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}


/* Payload é um Json object que tem de fazer match com SearchRequest*/
export function loadHospitalItem ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/hospital',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}

/* Payload é um Json object que tem de fazer match com SearchRequest*/
export function loadMedicoItem ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/medico',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}
export function setCurrentPage ({Vue, commit}, payload) {
    commit("setCurrentPage", payload);
}

export function scrollFrameTop() {
    setTimeout(() => {
        console.log("scrollFrameTop");
        if (window.parentIFrame) {
            window.parentIFrame.scrollTo(0, 0);
        }
        window.scrollTo(0, 0);
    }, 750);
}

export function changeFavoriteStatus ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/changeFavoriteStatus',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}

export function addAddressToCache ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/cacheAddress',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}

export function loadDistritosConcelhosItem ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/distritosconcelhos',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}


export function loadProtocoloPreData ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/protocolopredata',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}


/* Payload é um Json object que tem de fazer match com SearchRequest*/
export function loadProtocoloItem ({Vue, commit}, payload) {    // tas a ver payload aqui ? y
    return axios.post('rest/protocolo',    //
        payload
    )
        .then((response) => {
            /*O que vem aqui é o SearchResponse do controller*/
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}


export function loadEspecialidades ({Vue, commit}) {
    return axios.get('rest/especialidades')
        .then((response) => {
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}

export function loadAreasByEspecialidades ({Vue, commit}, payload) {
    return axios.post('rest/distritosconcelhos/filtered', payload)
        .then((response) => {
            //console.log(response.data.id);
            return response.data;
        }).catch((error) => {
            console.log('Error detected ? ' + error);
            throw error
        })
}

export function checkDirPesToken ({Vue, commit}, payload) {
    return axios.post('rest/checktoken', payload)
        .then((response) => {
            commit('setLoggedUser', response.data.user);
            commit('setLoggedToken', response.data.token);
            return response.data;
        }).catch((error) => {
            commit('setLoggedUser', '');
            commit('setLoggedToken', '');
            console.log('Error detected ? ' + error);
            throw error
        })
}
